import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ActionIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d="M0,15V5h3l0,2H2v6h9l0-4h2v6H0z M11,6c0,0-0.7-0.2-2.4,0c-2.8,0.3-4.5,2-4.5,2s1.3-3.8,4.6-4.5  C11.3,2.9,11,3,11,3V1l4.9,3.3L11,8V6z"/>
  ]
  getViewBox = () => '0 0 16 16'
}


